import React, { useState, useEffect } from 'react';
import Select from '../../../components/ui/Select';

const BrandModelFilter = ({ selectedBrand, selectedModel, onBrandChange, onModelChange }) => {
  const [availableModels, setAvailableModels] = useState([]);

  const brands = [
    { value: 'toyota', label: 'Toyota' },
    { value: 'honda', label: 'Honda' },
    { value: 'nissan', label: 'Nissan' },
    { value: 'mercedes', label: 'Mercedes-Benz' },
    { value: 'bmw', label: 'BMW' },
    { value: 'volkswagen', label: 'Volkswagen' },
    { value: 'peugeot', label: 'Peugeot' },
    { value: 'renault', label: 'Renault' },
    { value: 'hyundai', label: 'Hyundai' },
    { value: 'kia', label: 'Kia' },
    { value: 'ford', label: 'Ford' },
    { value: 'chevrolet', label: 'Chevrolet' },
    { value: 'mitsubishi', label: 'Mitsubishi' },
    { value: 'suzuki', label: 'Suzuki' },
    { value: 'mazda', label: 'Mazda' }
  ];

  const modelsByBrand = {
    toyota: [
      { value: 'camry', label: 'Camry' },
      { value: 'corolla', label: 'Corolla' },
      { value: 'rav4', label: 'RAV4' },
      { value: 'prado', label: 'Land Cruiser Prado' },
      { value: 'hilux', label: 'Hilux' },
      { value: 'yaris', label: 'Yaris' },
      { value: 'avensis', label: 'Avensis' }
    ],
    honda: [
      { value: 'civic', label: 'Civic' },
      { value: 'accord', label: 'Accord' },
      { value: 'crv', label: 'CR-V' },
      { value: 'pilot', label: 'Pilot' },
      { value: 'fit', label: 'Fit' }
    ],
    nissan: [
      { value: 'altima', label: 'Altima' },
      { value: 'sentra', label: 'Sentra' },
      { value: 'pathfinder', label: 'Pathfinder' },
      { value: 'murano', label: 'Murano' },
      { value: 'navara', label: 'Navara' }
    ],
    mercedes: [
      { value: 'c-class', label: 'C-Class' },
      { value: 'e-class', label: 'E-Class' },
      { value: 'glc', label: 'GLC' },
      { value: 'gle', label: 'GLE' },
      { value: 'sprinter', label: 'Sprinter' }
    ],
    bmw: [
      { value: '3-series', label: '3 Series' },
      { value: '5-series', label: '5 Series' },
      { value: 'x3', label: 'X3' },
      { value: 'x5', label: 'X5' },
      { value: 'x1', label: 'X1' }
    ],
    peugeot: [
      { value: '206', label: '206' },
      { value: '207', label: '207' },
      { value: '307', label: '307' },
      { value: '407', label: '407' },
      { value: '508', label: '508' }
    ]
  };

  useEffect(() => {
    if (selectedBrand && modelsByBrand?.[selectedBrand]) {
      setAvailableModels(modelsByBrand?.[selectedBrand]);
    } else {
      setAvailableModels([]);
      onModelChange('');
    }
  }, [selectedBrand, onModelChange]);

  return (
    <div className="space-y-4">
      <Select
        label="Marque / Brand"
        placeholder="Sélectionner une marque / Select brand"
        options={brands}
        value={selectedBrand}
        onChange={onBrandChange}
        searchable
        clearable
        description="Choisissez la marque du véhicule / Choose vehicle brand"
      />

      {selectedBrand && (
        <Select
          label="Modèle / Model"
          placeholder="Sélectionner un modèle / Select model"
          options={availableModels}
          value={selectedModel}
          onChange={onModelChange}
          searchable
          clearable
          description="Choisissez le modèle spécifique / Choose specific model"
        />
      )}
    </div>
  );
};

export default BrandModelFilter;